module.exports = __webpack_public_path__ + "media/seher_1.1j.32c77b90.mp3";